import { render, staticRenderFns } from "./PlotLegend.vue?vue&type=template&id=8af9261e&"
import script from "./PlotLegend.vue?vue&type=script&lang=js&"
export * from "./PlotLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports